export default __webpack_public_path__ + "static/media/decor13.d3a2da3a.webp";